import OpportunityCampaignStore from './opportunity-campaign'

export default class OpportunityStore extends OpportunityCampaignStore {}
